import {
  AddToPhotos,
  CheckCircle,
  Delete,
  DeleteSweep,
  Info,
  LocalShipping,
  MenuOpen,
  Print,
} from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

export default function TableDropwdownActions({
  handleDeliveryOrderBack,
  handleDriverSend,
  printDeliveryOrder,
  handleDetailData,
  deleteClassItem,
  deleteItem,
  activeClassItem,
  styles,
  row,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const role = useSelector((state) => state.auth.dataToken.roleId.roleName);
  const roleArray = ["super-admin", "admin"];
  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={() => {
          setAnchorEl(event.target);
          setOpen(true);
        }}
      >
        <MenuOpen />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        {row.status === 1 && (
          <MenuItem onClick={() => printDeliveryOrder()}>
            <Print className={styles.actionButtonEdit} fontSize="small" />
            Cetak Surat Jalan
          </MenuItem>
        )}

        {row.status === 2 && (
          <MenuItem onClick={() => handleDriverSend()}>
            <LocalShipping
              className={styles.actionButtonEdit}
              fontSize="small"
            />
            Terkirim
          </MenuItem>
        )}

        {row.status === 3 && (
          <MenuItem onClick={() => handleDeliveryOrderBack()}>
            <CheckCircle className={styles.actionButtonEdit} fontSize="small" />
            Surat Jalan Kembali
          </MenuItem>
        )}

        <MenuItem onClick={() => handleDetailData()}>
          <Info className={styles.actionButtonEdit} fontSize="small" />
          Detail
        </MenuItem>

        {roleArray.indexOf(role) > -1 && (
          <>
            {/* SJ tidak bisa diedit ketika diterbitkan */}
            {/* <MenuItem onClick={() => handleEditData()}>
              <EditIcon className={styles.actionButtonEdit} fontSize="small" />
              Edit
            </MenuItem> */}

            <MenuItem onClick={() => deleteItem()}>
              <DeleteSweep
                className={styles.actionButtonDelete}
                fontSize="small"
              />
              Delete
            </MenuItem>
          </>
        )}

        {role === "super-admin" && (
          <MenuItem onClick={() => deleteClassItem()}>
            <Delete className={styles.actionButtonDelete} fontSize="small" />
            Delete Permanent
          </MenuItem>
        )}

        {role === "super-admin" && !row.isActive && (
          <MenuItem onClick={() => activeClassItem()}>
            <AddToPhotos className={styles.actionButtonEdit} fontSize="small" />
            Aktifkan
          </MenuItem>
        )}
      </Menu>
    </>
  );
}

TableDropwdownActions.propTypes = {
  handleDeliveryOrderBack: PropTypes.func.isRequired,
  handleDriverSend: PropTypes.func.isRequired,
  printDeliveryOrder: PropTypes.func.isRequired,
  handleEditData: PropTypes.func.isRequired,
  handleDetailData: PropTypes.func.isRequired,
  deleteClassItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  activeClassItem: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
};
